import { SET_PAYMENT_ERROR, SET_PAYMENT_STAGE, SET_PAYMENT_URL,SET_PAYMENTS_DETAILS} from "../const";


export interface IPaymentState {
    paymentURL: string;
    isError: boolean;
    paymentStage: number;
    paymentDetails:{
        venueName:string;
        acquirerName:string;
        paymentProcessor:string;
        onboardingSource:string;
    }
}

const initalState = {
    paymentURL: "",
    isError: false,
    paymentStage: -1,
    paymentDetails:{
        venueName:"",
        acquirerName:"",
        paymentProcessor:"",
        onboardingSource:""
    }
};
export function paymentReducer(state: IPaymentState = initalState, action: any) {
    switch (action.type) {
        case SET_PAYMENT_ERROR:
            return {
                ...state,
                isError: action.payload
            };
        case SET_PAYMENT_URL:
            return {
                ...state,
                paymentURL: action.payload
            };
        case SET_PAYMENT_STAGE:
            return {
                ...state,
                paymentStage: action.payload
            };
        case SET_PAYMENTS_DETAILS:
            return {
                ...state,
               paymentDetails:action.payload,
            };    
        default:
            return state;
    }
}